import React, { FC, useEffect, useState, Dispatch, SetStateAction, useContext } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { LogD } from '../../../function/LogLapper';
import { Grid } from '@material-ui/core';
import SelectSettings, { MenuContents } from '../../organisms/SelectSettings';
import StorageCapacitySettingPage from './StorageCapacitySetting/StorageCapacitySettingPage';
import LoginUserSettingPage from './LoginUserSetting/LoginUserSettingPage';
import PLMSettingPage from './PLMSetting/PLMSettingPage';

import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';

type CustomConfigPageProps = {};

const CustomConfigPage: React.FC<CustomConfigPageProps> = (props) => {
  const { t } = useTranslation();
  const { login } = useContext(AppContext);

  const menuList: MenuContents[] = [
    {
      name: t('CustomConfigPageProps.ユーザ管理画面', 'ユーザ管理画面'),
      component: LoginUserSettingPage,
      tag: 'Login',
    },
    { name: t('CustomConfigPageProps.PLM連携設定', 'PLM連携設定'), component: PLMSettingPage, tag: 'PLM' },
    {
      name: t('CustomConfigPageProps.ストレージ容量設定', 'ストレージ容量設定'),
      component: StorageCapacitySettingPage,
      tag: 'StorageCapacitySetting',
    },
  ];

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ marginRight: 0 }}>
      <SelectSettings menuList={menuList} />
    </Grid>
  );
};

export default CustomConfigPage;
